import PrincipalNavigation from "./navigations/PrincipalNavigation";
import "../src/assets/styles/general.css";
import { isProduction } from "./configurations/Axios/Clients";
import ErrorBoundary from "./components/composed-styled-components/ErrorBundary/ErrorBundary";

function App() {
  return (
    <ErrorBoundary>
      <div
        style={
          !isProduction()
            ? {
                boxShadow: "0 0 20px 5px rgba(0, 255, 0, 0.7)",
                transition: "box-shadow 0.3s ease",
                margin: "10px",
              }
            : {}
        }
      >
        <div id="main-content" role="main">
          <PrincipalNavigation />
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default App;
